/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2020-8-7 15点16分
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2020-8-7 15点16分
 */

const state = {
  parkActivitiesDetail: []
}

const actions = {
  set_parkActivitiesDetail(context, option) {
    context.commit('set_parkActivitiesDetail', option)
  }
}

const getters = {}

const mutations = {
  set_parkActivitiesDetail(state, option) {
    state.parkActivitiesDetail = option
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/circle/parkActivitiesDetail.js